import {
  AbstractControl,
  AsyncValidator,
  AsyncValidatorFn,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { DefaultService as KontoverbindungenService, IbanToBicDto } from '@kontoverbindungen-api';
import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { bicValidator } from './bic.validator';

@Injectable({
  providedIn: 'root',
})
export class IbanBicValidator implements AsyncValidator {
  hasException = new BehaviorSubject<boolean>(false);
  backendResponse = new EventEmitter<IbanToBicDto>();

  constructor(private service: KontoverbindungenService) {}

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    const ibanControl = control;
    const parentFormGroup = control.parent;
    const bicControl = parentFormGroup?.get('bic');

    if (!ibanControl?.value || !bicControl) {
      return of(null);
    }

    return this.service.ibanToBic(this.removeWhitespaces(ibanControl.value).toUpperCase()).pipe(
      map((response: IbanToBicDto) => {
        if (response.isBicRequired && !response.bic) {
          bicControl.addValidators(bicValidator());
          bicControl.addValidators(Validators.required);
          bicControl.enable();
        }

        if (!response.isBicRequired) {
          bicControl.removeValidators(bicValidator());
          bicControl.removeValidators(Validators.required);
          bicControl.disable();
        }

        bicControl.setValue(response.bic ?? '');
        bicControl.updateValueAndValidity();
        this.hasException.next(false);
        this.backendResponse.emit(response);

        return !response.isIbanValid ? { ibanInvalid: true } : null;
      }),
      catchError(() => {
        this.hasException.next(true);
        return of(null);
      })
    );
  }

  validatorFn(): AsyncValidatorFn {
    return (control: AbstractControl) => this.validate(control);
  }

  private removeWhitespaces(iban: string): string {
    return iban.replace(/\s/g, '');
  }
}
